//THEME
import marquee from "./custom/marquee";
import navbar from "./custom/navbar";
import presentation from "./custom/presentation";
import realisations from "./custom/realisations";
import ctaBlock from "./custom/cta-block";
import testimonials from "./custom/testimonials";
import products from "./custom/products";
//import equipe from "./custom/equipe";
import subscriberForms from "./custom/subscriber-forms";
import disclaimerPopup from "./custom/disclaimer-popup";
